// extracted by mini-css-extract-plugin
export default {"desiredResolutionPagePillButtons":"DesiredResolution_desiredResolutionPagePillButtons__AvWr-"};